import { localeTagForLanguage, normalizeLanguage } from './constants';

export function resolveLocaleTag(languageOrLocale?: string | null): string {
  return localeTagForLanguage(normalizeLanguage(languageOrLocale ?? undefined));
}

export function isSerbianLocale(tag: string): boolean {
  return tag.toLowerCase().startsWith('sr');
}

/** Kratki datum za ose grafikona (npr. 3. 6. ili Jun 3). */
export function shortDateFormatOptions(tag: string): Intl.DateTimeFormatOptions {
  return isSerbianLocale(tag)
    ? { day: 'numeric', month: 'numeric' }
    : { month: 'short', day: 'numeric' };
}

/** Datum bez vremena (npr. 3. 6. 2026. ili Jun 3, 2026). */
export function dateFormatOptions(tag: string): Intl.DateTimeFormatOptions {
  return isSerbianLocale(tag)
    ? { day: 'numeric', month: 'numeric', year: 'numeric' }
    : { year: 'numeric', month: 'short', day: 'numeric' };
}

/** Datum + vreme (kolona Vreme, timeline, itd.). */
export function dateTimeFormatOptions(tag: string): Intl.DateTimeFormatOptions {
  if (isSerbianLocale(tag)) {
    return {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };
  }
  return {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  };
}

/** Samo vreme (npr. 08:05). */
export function timeFormatOptions(tag: string): Intl.DateTimeFormatOptions {
  return {
    hour: '2-digit',
    minute: '2-digit',
    hour12: !isSerbianLocale(tag),
  };
}

/** Dan u nedelji + datum (ERV skorašnji zapisi). */
export function weekdayDateFormatOptions(tag: string): Intl.DateTimeFormatOptions {
  return isSerbianLocale(tag)
    ? {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      }
    : {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      };
}
